import {
    type CollectivesFundMeta,
    type ETFFundMeta,
    type PMCFundMeta,
} from "@hsl/fund-explorer/metaSchemas";
import { type FieldMeta } from "@hsl/fund-explorer/types";

import useExplorerStore from "../store/store";

type CollectiveProps = {
    type: "collective";
    fundFields: (keyof CollectivesFundMeta)[];
};

type PMCProps = {
    type: "pmc";
    fundFields: (keyof PMCFundMeta)[];
};

type ETFProps = {
    type: "etf";
    fundFields: (keyof ETFFundMeta)[];
};

export type Props = CollectiveProps | PMCProps | ETFProps;

function useFundFieldMeta({ fundFields }: Props) {
    const getMeta = useExplorerStore((state) => state.getMeta);
    const metaData = fundFields.map((field) =>
        (getMeta("fund_fields") as FieldMeta[]).find(
            (f) => f.code_name === field,
        ),
    );
    return metaData;
}

export default useFundFieldMeta;
